// Scripts
import '~scripts/main';

// Styles
import 'styles/pages/specials/bez-opyta.scss';

// Packages
import Vue from 'vue';

// Core
import { scrollAnimationProgress } from '~scripts/core/animations';
import { BREAKPOINTS } from '~scripts/core/breakpoints';

// Blocks
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';
import SpecialsVideo from '~scripts/blocks/vue/SpecialsVideo.vue';

// Components
import '~scripts/components/modals';

// Media
const mediaSm = window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);
const mediaMd = window.matchMedia(`(max-width: ${BREAKPOINTS.mdMin})`);
const mediaLg = window.matchMedia(`(max-width: 1200px)`);

//
// HEADER
//
Header();

//
// NAVIGATION
//
Navigation(mediaLg);

//
// BANNER
//
// Photo
const bannerEl = document.querySelector('.js-banner');
let stopBannerPhotoAnimation = null;

const handleBannerPhotoAnimation = () => {
  const bannerPhoto = document.querySelector('.js-banner-img');

  if (mediaSm.matches) {
    if (stopBannerPhotoAnimation && typeof stopBannerPhotoAnimation === 'function') {
      stopBannerPhotoAnimation();
    }
  } else {
    stopBannerPhotoAnimation = scrollAnimationProgress(bannerPhoto, {
      getStart() {
        return 0;
      },
      getEnd(el, start) {
        const bannerHeight = bannerEl.offsetHeight;
        return start + bannerHeight;
      },
    });
  }
};

handleBannerPhotoAnimation();
mediaSm.addEventListener('change', handleBannerPhotoAnimation);

//
// STATISTIC
//
let stopStatisticScrollAnimation = null;

const handleStatisticPhotoAnimation = () => {
  const statisticAnimation = document.querySelector('.js-statistic');

  if (mediaSm.matches) {
    if (stopStatisticScrollAnimation && typeof stopStatisticScrollAnimation === 'function') {
      stopStatisticScrollAnimation();
    }
  } else {
    stopStatisticScrollAnimation = scrollAnimationProgress(statisticAnimation, {
      getStart(el) {
        const rect = el.getBoundingClientRect();

        return rect.top + window.scrollY - window.innerHeight;
      },
      getEnd(el, start) {
        return start + el.offsetHeight;
      },
    });
  }
};

handleStatisticPhotoAnimation();
mediaMd.addEventListener('change', handleStatisticPhotoAnimation);

//
// TEXT ANIMATION
//
let stopFadeInAnimation = [];

const handleFadeInAnimation = () => {
  const items = document.querySelectorAll('.js-person, .js-text-animation > p');

  if (mediaSm.matches) {
    stopFadeInAnimation.forEach((stop) => stop());
  } else {
    stopFadeInAnimation = Array.from(items, (item) => {
      return scrollAnimationProgress(item, {
        getStart(el) {
          const rect = el.getBoundingClientRect();
          return rect.top + window.scrollY - (window.innerHeight - 200);
        },
        getEnd(el, start) {
          const height = el.offsetHeight;
          return start + (window.innerHeight / 2 - height / 2);
        },
      });
    });
  }
};

handleFadeInAnimation();
mediaSm.addEventListener('change', handleFadeInAnimation);

//
// VIDEO
//
const conclusionsVideos = document.querySelectorAll('.js-conclusions-item-video');

conclusionsVideos.forEach((video) => {
  new Vue({
    el: video,
    name: 'SpecialsVideo',
    components: {
      SpecialsVideo,
    },
  });
});

//
// FOOTER
//
const body = document.body;
const main = document.querySelector('.js-main');
const footer = document.querySelector('.js-footer');
const headerHeight = 64;

const scroll = {
  handle() {
    const footerHeight = footer.offsetHeight;

    footer.style.visibility = window.scrollY === 0 ? 'hidden' : 'visible';

    if (window.scrollY > main.offsetHeight) {
      setTimeout(() => {
        body.style.paddingBottom = null;
      }, 0);

      if (window.innerHeight > footerHeight) {
        footer.style.position = 'static';
      } else {
        footer.style.position = 'relative';
      }
    } else {
      body.style.paddingBottom = `${footerHeight}px`;
      footer.style.position = 'fixed';

      if (window.innerHeight > footerHeight) {
        footer.style.removeProperty('top');
        footer.style.bottom = '0';
      } else {
        footer.style.removeProperty('bottom');
        footer.style.top = `${headerHeight}px`;
      }
    }
  },
  on() {
    this.handle();

    document.addEventListener('scroll', this.handle);
    window.addEventListener('resize', this.handle);
  },
  off() {
    body.style.paddingBottom = null;
    footer.style.position = 'static';

    document.removeEventListener('scroll', this.handle);
    window.removeEventListener('resize', this.handle);
  },
};

// Scroll
window.addEventListener('DOMContentLoaded', () => {
  if (!mediaSm.matches) {
    scroll.on();
  }

  mediaSm.addEventListener('change', () => {
    if (!mediaSm.matches) {
      scroll.on();
    } else {
      scroll.off();
    }
  });
});

window.addEventListener('load', () => {
  if (!mediaSm.matches) {
    scroll.handle();
  }
});

// Animation
let stopFooterAnimation = null;

const handleFooterAnimation = () => {
  if (mediaSm.matches) {
    if (stopFooterAnimation && typeof stopFooterAnimation === 'function') {
      stopFooterAnimation();
    }
  } else {
    stopFooterAnimation = scrollAnimationProgress(body, {
      getStart() {
        const rect = main.getBoundingClientRect();
        return rect.bottom + (window.scrollY - window.innerHeight);
      },
      getEnd(el, start) {
        return start + footer.offsetHeight - headerHeight;
      },
      lerpValue: 1,
    });
  }
};

handleFooterAnimation();
mediaSm.addEventListener('change', handleFooterAnimation);

//
// Metrics
//
const handleButtonClick = (e) => {
  const button = e.target.closest('.js-button');
  const dataMetric = button.getAttribute('data-metric');
  const metrics = window.bezOpytaMetrics();
  const isNotesCard = button.classList.contains('notes-card');

  if (metrics[dataMetric]) {
    metrics[dataMetric]();
  }

  if (isNotesCard) {
    metrics['bo_tezis']();
  }
};

const metricButtons = document.querySelectorAll('.js-button');

metricButtons.forEach((button) => {
  button.addEventListener('click', handleButtonClick);
});
